import { render } from "./PlaObs.vue?vue&type=template&id=4508123a&scoped=true"
import script from "./PlaObs.vue?vue&type=script&lang=js"
export * from "./PlaObs.vue?vue&type=script&lang=js"

import "@/assets/css/microfono.css?vue&type=style&index=0&id=4508123a&scoped=true&lang=css"
import "./PlaObs.vue?vue&type=style&index=1&id=4508123a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4508123a"]])

export default __exports__